import type { ReactNode } from 'react';
import { Badge, Text } from '@kognitos/lattice';
import {
  AssetConfigRailSection,
  type IAssetConfigRailSectionProps,
} from '@/layouts/AssetWorkspaceLayout';

/** Names a group of rows inside a rail block, so the Library's assets and
 *  collections don't read as one undifferentiated list. Quieter than the
 *  block's own title — it separates rows rather than heading the block. */
export function RailGroupLabel({ children }: { children: ReactNode }) {
  return (
    <Text
      level="xSmall"
      weight="medium"
      color="muted"
      className="px-1 pt-1 uppercase tracking-wide"
    >
      {children}
    </Text>
  );
}

/** The count chip on a rail block's header. */
export function RailCountBadge({ count }: { count: number }) {
  return (
    <Badge variant="secondary" className="tabular-nums">
      {count}
    </Badge>
  );
}

/** A collapsible block of the draft rail: title, optional count and action. */
export function DraftRailSection(props: IAssetConfigRailSectionProps) {
  return (
    <AssetConfigRailSection
      data-testid={`draft-rail-section-${props.name}`}
      {...props}
    />
  );
}
